﻿.config-section-header {
  padding-bottom: 0.8em;
}

.config-select {
  min-width: 400px;
  margin-right: 80px;
}